import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from "@angular/router";
import { Auth } from "aws-amplify";
import { sntLog } from "src/app/common/logger";
import {
  resolveAuthErrorMessage,
  setAuthFlashError
} from "src/app/modules/auth/auth.support";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";

const logger = sntLog("AuthenticateWithTokenGuard");

@Injectable()
export class AuthenticateWithTokenGuard implements CanActivate {
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    logger.debug("canActivate");

    const token = route.queryParamMap.get("token");

    if (!token) {
      return true;
    }

    try {
      const decodedToken = atob(token);

      const username = decodedToken.split(":")[0];
      const password = decodedToken.split(":")[1];

      if (!!username && !!password) {
        await Auth.signIn(username, password);
      }
    } catch (ex: unknown) {
      logger.error(ex);

      setAuthFlashError(
        resolveAuthErrorMessage(
          ex,
          sntTranslate(marker("Impossibile effettuare l'accesso automatico."))
        )
      );
    }

    return true;
  }
}
